/**
 * Reads the HTTP status out of an RTK Query error.
 *
 * `axiosBaseQuery` is typed as a bare `BaseQueryFn`, so RTK Query exposes the
 * error as `unknown` even though it always normalizes failures to
 * `{ status, data }`. A network failure has no response, so `status` is
 * `undefined` there — callers must treat `undefined` as "not a known status",
 * never as a specific one.
 *
 * Pass the **inner** error: what a hook returns as `error`, or — inside
 * `onQueryStarted` — `caught.error`, since `queryFulfilled` rejects with the
 * lifecycle envelope `{ error, isUnhandledError, meta }` rather than the error
 * itself.
 */
export const getRtkErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null || !('status' in error)) {
    return undefined;
  }
  const { status } = error as { status: unknown };
  return typeof status === 'number' ? status : undefined;
};
